import React, { useContext } from "react";
import { PostPurchaseContext } from "../context/PostPurchaseContext";

function Breadcrumbs({ blocks }) {
  const state = useContext(PostPurchaseContext);
  return (
    <ul className="grid grid-cols-[1fr,min-content,1fr] gap-x-[45px] text-center text-muted-400 relative before:absolute before:top-[30px] before:h-1 before:w-full before:bg-muted-400 before:-z-10 justify-center">
      {blocks.map((block) => {
        return (
          <li key={block.id} className="w-full bg-white grid grid-rows-[60px,1fr] content-center gap-y-2" style={{ '--bgColour': block.background }}>
            <div className={`${block.id === 1 ? "ml-auto" : ""} mx-[10px] flex justify-center items-center text-6xl font-medium border-4  rounded-full h-[60px] w-[60px] m-auto ${state.activeStep >= block.id ? "bg-[var(--bgColour)] border-[var(--bgColour)] text-white" : "border-current"}`}>
              {block.id}
            </div>
            <div className={`w-[80px] text-[15px] leading-8 ${block.id === 1 ? "ml-auto" : ""}`}>{block.title}</div>
          </li>
        );
      })}
    </ul>)
}

export default Breadcrumbs;
